module.exports = __webpack_public_path__ + "static/media/shanzelize Still 7.62287c07.webp";